const tunnel = {
  badge: "🚀 AI & FULL-STACK EXPERTISE",
  title: "Bring Your AI Project to Life: From Idea to Deployment",
  subtitle: "Do you have an application, SaaS, or automation project? Trust its execution to an expert who masters the entire technical chain.",
  
  benefits: {
    time: "Complete technical scoping to avoid costly design errors.",
    money: "Optimized architecture (MVP) to launch fast without wasting your budget.",
    speed: "Functional prototype delivered in less than 15 days to validate your market."
  },

  leadMagnetTitle: "🎯 Book Your Technical Scoping Session (Free)",
  leadMagnetSubtitle: "30 minutes to define the architecture of your future AI product",
  
  preview: {
    title: "On the agenda for this call:",
    auto1: "Technical feasibility analysis of your project.",
    auto2: "Technology stack choice (LLM, Backend, Frontend).",
    auto3: "MVP (Minimum Viable Product) scope definition.",
    auto4: "Realistic timeline and budget estimation.",
    auto5: "Recommendations on industrialization and deployment.",
    bonus: "Deliverable: A summary report with a personalized technical roadmap."
  },

  form: {
    firstName: "Your name",
    email: "Professional email",
    button: "📅 Book My Scoping Call",
    security: "🔒 Session limited to 5 projects per week."
  },

  demo: {
    title: "See the Solution in Action"
  },

  stats: {
    downloadsValue: "15+",
    downloadsLabel: "AI projects successfully deployed",
    deployedValue: "95%",
    deployedLabel: "client satisfaction on scoping",
    avgTimeValue: "< 15d",
    avgTimeLabel: "Functional prototype"
  },

  trust: {
    title: "Why trust me with your project?",
    scientific: "High-Level Expertise: Former InterDigital researcher, patent in Deep Learning.",
    pragmatic: "Product-Oriented: 4+ years experience transforming ideas into functional SaaS.",
    speed: "True Full-Stack: I handle everything from database to user interface."
  },

  testimonials: {
    title: "What my clients say",
    valerie: {
      name: "Valérie Noiton",
      role: "Head of Supply Chain – Eutelsat Group",
      content: "Alexandre shows true professional conscience. Highly involved in the project, he knew how to get the best out of the team to design a tool that deeply improved the daily lives of employees. His availability, listening skills, and ability to understand business issues made all the difference. The result is a reliable, useful tool perfectly adapted to operational needs."
    },
    jeanMichel: {
      name: "Jean-Michel",
      role: "Technical Chief – Eutelsat Group",
      content: "The tool developed by Alexandre is simply exceptional. It is a real strategic lever for the company. Alexandre stands out for his high reactivity, constant availability and ability to manage a project with rigor while remaining attentive to technical and business needs. His professionalism and sense of commitment make him an excellent project manager, capable of transforming a vision into a concrete and high-performance solution."
    },
    chris: {
      name: "Chris Stevens",
      role: "CFO – Takara UK",
      content: "Alexandre has strong technical skills and a deep understanding of client needs. He is able to navigate complex environments where project requirements are not always clearly defined. His ability to design, develop, and deploy a tool from scratch is an incredible achievement. Alexandre combines technical excellence with strong communication skills."
    },
    cedric: {
      name: "Cédric Magné",
      role: "CEO – CydJerr",
      content: "Alexandre was a major support throughout the mission. His ability to adapt quickly and propose realistic and viable solutions allowed him to successfully complete the project in a demanding context. Thanks to his full-stack expertise, he was notably able to redeploy a critical mobile application after a crash, in record time."
    },
    ahmed: {
      name: "Ahmed Ly",
      role: "PMO – Test de Menta Company",
      content: "The tool developed by Alexandre meets a real need for both managers and employees. His fine understanding of user expectations, supported by a rigorous and well-conducted market study, allowed him to design a truly relevant solution. This project perfectly illustrates Alexandre's ability to transform in-depth business analysis into a concrete, effective, and operational tool."
    }
  },

  closing: {
    title: "💎 Don't leave your project at the idea stage",
    subtitle: "The difference between success and failure often lies in the first technical decisions.",
    item1: "AI architecture validation",
    item2: "Current stack audit",
    item3: "Immediate action plan for your MVP",
    button: "🚀 Launch my project now",
    guarantee: "✅ 30 min of pure value, no obligation to collaborate."
  }
};

export default tunnel;
